
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perennial-signup",
      function () {
        return require("private-next-pages/perennial-signup/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perennial-signup"])
      });
    }
  